<template>
  <div id="app" :class="{ headless: headless }">
   
     <div class="max-w-lg w-full mx-auto flex" v-if="($route.path !== '/nottingham-register' && $route.path !== '/adelaide-register')">
          <img v-if="organiser?.tenant == 'gfpevents'"  class="mx-auto" src="./assets/GFP_Events_logo_portrait.png" alt="MyGraduationClip" width="150" />
            <img v-else class="mx-auto" src="./assets/mgclogo.png" alt="MyGraduationClip" width="160" />
        </div>
    <loading v-if="!ready" />
    <router-view
      v-if="ready"
      :organiser="organiser"
      :events="this.events"
      :additionalFieldsInput="additionalFields"
      :key="$route.fullPath" 
    ></router-view>
    <!--
    <register-form
      msg="Sign up for your GraduationClip"
      class="mx-auto"
      :organiser="organiser"
      :events="events"  
    />-->
  </div>
</template>

<script>
import Loading from "./components/Loading.vue";
import Auth from "./api/auth";
import axios from "axios";
import { startSession, endSession, iOS } from './Analytics.vue';

// listen for all the exit events
window.addEventListener('pagehide', endSession)
window.addEventListener('beforeunload', endSession)
window.addEventListener('unload', endSession)

// for iOS when the focus leaves the tab
if (iOS()) window.addEventListener('blur', endSession)

export default {
  name: "App",
  components: { Loading  },
  data: function () {
    return {
      ready: false,
      organiser: null,
      events: null,
      signedIn: false,
      additionalFields: [],
    };
  },
  methods: {

  },
  computed: {
    headless() {
      return this.$route.query.headless !== undefined;
    },
  },
  beforeCreate() {
    console.log(this.$route.path)
    const token = localStorage.getItem("token")
    if (token) {
       axios.defaults.headers.common["Authorization"] =
            "Bearer " + token;
    }
    if (this.$route.matched.some(({ path }) => path.includes("admin") || path.includes("privacy-policy"))) {
      console.log(this.ready)
    } else {
      var sub = this.$route.query.uni;
      if (
        typeof sub == "undefined" &&
        typeof this.$route.params.uni != "undefined"
      ) {
        sub = this.$route.params.uni;
      }
      if (typeof sub == "undefined") {
        const registerMatch = this.$route.path.match(/^\/([^/]+)-register\/?$/);
        if (registerMatch) {
          sub = registerMatch[1];
        } else if (this.$route.params["uni-register"]) {
          sub = this.$route.params["uni-register"].replace(/-register$/, "");
        }
      }
      const utmParams = {};
      ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach(
        (k) => {
          if (this.$route.query[k]) {
            utmParams[k] = this.$route.query[k];
          }
        }
      );

      axios
        .get(`/universities/slug/${sub}`)
        .then((response) => response.data)
        .then(
          (response_data) => (
            (this.organiser = response_data),
            (this.events = response_data["ceremonies"]),
            (this.additionalFields = response_data["additionalFields"]),
            Auth.startSessionForTenant(response_data["tenant"]).then(() => {
              this.ready = true;
            }),
            startSession(response_data["tenant"], this.$route, {
              universitySlug: sub,
              ref: document.referrer,
              userAgent: navigator.userAgent,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
              ...utmParams,
            })
          )
        );
    }
    // Once we have a university then get a JWT
  },
  created() {
    if (this.$route.matched.some(({ path }) => path.includes("admin")  || path.includes("privacy-policy"))) {
        this.ready = true;
        }
  },
};
</script>

<style>
body {
  margin: 1rem;
  padding: 1rem;
  background-color: #FAFCFF;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app.headless {
  margin: 0;
  padding: 0;
}

.logo {
  max-width: 100%;
}
.text-mygrad {
  color: #08697b;
}
.border-gray {
    border-color: #D1D5DA;
}

.text-primary {
    color: #111827;
}

.text-secondary {
    color: #6A7280;
}
.bg-mygrad {
  background-color: #08697b;
}
.bg-mygrad-light {
  background-color: #05b1d2 !important;
}
.text-mygrad-light {
  color: #05b1d2;
}
</style>
